"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = exports.TypographyListItem = void 0;
var _react = require("react");
var _Icon = _interopRequireDefault(require("../Icon"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _TypographyListContext = _interopRequireDefault(require("./TypographyListContext"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon"));
var _styles = require("@mui/styles");
var _clsx3 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"],
  _excluded2 = ["variant", "color", "icon", "tooltip", "type", "disableTooltip", "iconProps", "noWrap", "zeroMinWidth", "divider", "spacing"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dataCy = exports.dataCy = 'TypographyListItem';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(_ref) {
      var variant = _ref.variant,
        color = _ref.color,
        divider = _ref.divider;
      var colors = {
        inherit: 'inherit',
        primary: theme.palette.primary.main,
        secondary: theme.palette.secondary.main,
        textPrimary: theme.palette.text.primary,
        textSecondary: theme.palette.text.secondary,
        error: theme.palette.error.main
      };
      var rootStyles = _objectSpread(_objectSpread({}, theme.typography[variant]), {}, {
        color: color !== 'initial' ? colors[color] : undefined,
        padding: 0
      });
      if (divider) {
        rootStyles['&:last-child'] = {
          '& span:last-child': {
            display: 'none'
          }
        };
      }
      return rootStyles;
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    zeroWinWidth: {
      minWidth: 0
    },
    icon: {
      minWidth: 24,
      alignItems: 'center',
      lineHeight: 'inherit'
    },
    holder: {
      display: 'block',
      position: 'relative',
      flex: '1 1 auto',
      minWidth: 0
    },
    bullet: {
      '&:after': {
        content: '""',
        width: 3,
        height: 3,
        position: 'absolute',
        top: 8,
        left: 3,
        backgroundColor: theme.palette.text.icon,
        borderRadius: '50%'
      },
      '&&': {
        paddingLeft: 16
      }
    },
    divider: function divider(_ref2) {
      var spacing = _ref2.spacing;
      return {
        paddingRight: theme.spacing(spacing)
      };
    }
  };
}, {
  name: 'GgTypographyListItem'
});
var TypographyListItem = exports.TypographyListItem = function TypographyListItem(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded);
  var listContext = (0, _react.useContext)(_TypographyListContext["default"]);
  var _listContext$props = _objectSpread(_objectSpread({}, listContext), props),
    variant = _listContext$props.variant,
    color = _listContext$props.color,
    icon = _listContext$props.icon,
    tooltip = _listContext$props.tooltip,
    type = _listContext$props.type,
    disableTooltip = _listContext$props.disableTooltip,
    iconProps = _listContext$props.iconProps,
    noWrap = _listContext$props.noWrap,
    zeroMinWidth = _listContext$props.zeroMinWidth,
    divider = _listContext$props.divider,
    _listContext$props$sp = _listContext$props.spacing,
    spacing = _listContext$props$sp === void 0 ? 0 : _listContext$props$sp,
    other = _objectWithoutProperties(_listContext$props, _excluded2);
  var listItemClasses = useStyles({
    variant: variant,
    color: color,
    divider: divider,
    spacing: spacing
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
    title: disableTooltip ? '' : tooltip || children,
    arrow: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem["default"], _objectSpread(_objectSpread({
      component: 'div',
      "data-cy-variant": variant,
      "data-cy-color": color,
      "data-cy": dataCy,
      "data-cy-list-item-type": type
    }, other), {}, {
      className: (0, _clsx3["default"])(listItemClasses.root, _defineProperty(_defineProperty({}, listItemClasses.noWrap, noWrap), listItemClasses.zeroMinWidth, zeroMinWidth)),
      children: [icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
        className: listItemClasses.icon,
        component: 'span',
        as: 'span',
        children: React.cloneElement(icon, _objectSpread({
          sx: {
            fontSize: 20
          }
        }, iconProps))
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _clsx3["default"])(listItemClasses.holder, _defineProperty(_defineProperty({}, listItemClasses.bullet, type === 'bullet'), listItemClasses.noWrap, noWrap)),
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: listItemClasses.divider,
        children: divider
      })]
    }))
  });
};
var _default = exports["default"] = TypographyListItem;